<template>
  <md-card>
    <md-card-content>
      <form class="md-layout md-gutter">
        <div class="md-layout-item md-size-33 md-xsmall-size-100">
          <md-field>
            <label>Almacenes</label>
            <md-select
              v-model="value.warehouse"
              name="warehouse"
              id="warehouse"
              :disabled="!catalogs.warehouses.length || loading"
            >
              <md-option
                v-for="warehouse in catalogs.warehouses"
                :key="warehouse.id"
                :value="warehouse.id"
              >
                {{ warehouse.name }}
              </md-option>
            </md-select>
            <md-tooltip v-if="!catalogs.warehouses.length">
              No hay autopistas seleccionables
            </md-tooltip>
          </md-field>
        </div>

        <div
          v-show="value.warehouse"
          class="md-layout-item md-size-33 md-xsmall-size-100"
        >
          <md-field>
            <label>Ordenes de compra</label>
            <md-select
              v-model="value.purchaseOrder"
              name="purchaseOrder"
              id="purchaseOrder"
              :disabled="!catalogs.purchaseOrders.length || loading"
            >
              <md-option
                v-for="purchaseOrder in catalogs.purchaseOrders"
                :key="purchaseOrder.id"
                :value="purchaseOrder.id"
              >
                {{ purchaseOrder.folio }}
              </md-option>
            </md-select>
            <md-tooltip v-if="!catalogs.purchaseOrders.length">
              No hay ordenes de compra seleccionables
            </md-tooltip>
          </md-field>
        </div>
      </form>
    </md-card-content>
  </md-card>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    catalogs: {
      type: Object,
      default: () => [],
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/InputFromPurchaseOrder/Filters.vue